<!-- <app-data-table [columns]="cols" [data]="kmpData" (onAdd)="onAdd('add')" [title]="'KMP Master'" [isCardView]="false" 
  [isDeletable]="'/master/kmp' | hasPermission: 'Delete'"  [showAddButton]="'/master/kmp' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/kmp' | hasPermission: 'Edit'" [isView]="'/master/kmp' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"  (editEventRow)="updateKMP($event)" (onLazyLoadData)="getAllKmp($event)" [totalRecords]="totalRecords" [url]="'/master/kmp/'"
  (deleteEventRow)="showDeletePopup($event)" ></app-data-table> -->

  <ng-container>

  <app-data-table [columns]="cols" [data]="kmpData" [isCardView]="false" [url]="'/master/kmp/'"
    [isDeletable]="'/master/kmp' | hasPermission: 'Delete'"  [isView]="'/master/kmp' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)" 
    [showAddButton]="'/master/kmp' | hasPermission: 'Add'" [showActions]="canEditSetup"
    [isEditable]="'/master/kmp' | hasPermission: 'Edit'" (onPresentView)=" getAllKmp()" [title]="title"
    (onAdd)="onAdd('add')" (editEventRow)="updateKMP($event)" (deleteEventRow)="showDeletePopup($event)"
    (onLazyLoadData)="getAllKmp($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>

<p-dialog header="General Legal Policy / Charter Duties" [(visible)]="isDialogVisible" [modal]="true" [draggable]="false" [resizable]="false"
   [style]="{width: '50vw'}" [maximizable]="true">
  <form [formGroup]="kmpForm" class="p-3 my-1 bg-slate-50 shadow-md">
    <div class="mb-4">
      <label for="name" class="block text-sm font-semibold text-slate-700 mb-2">
        Enter file name
      </label>
      <input
        id="name"
        type="text"
        class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 text-slate-700"
        placeholder="Enter extra value"
        formControlName="name"
        autocomplete="off"
      />
    </div>
    <div class="mb-4">
      <label class="block text-sm font-semibold text-slate-700 mb-2">
        Multi-select Example
      </label>
      <p-multiSelect
        [options]="schemes"
        formControlName="scheme"
        optionLabel="name"
        optionValue="id"
        placeholder="Choose options"
        display="chip"
        styleClass="w-full rounded"
        appendTo="body"
      ></p-multiSelect>
    </div>
    <div class="mb-4">
      <label for="reference_document_remark" class="block text-sm font-semibold text-slate-700 mb-2">
        Description <span class="text-danger">*</span>
      </label>
      <textarea
        pInputTextarea
        id="reference_document_remark"
        rows="5"
        pSize="large"
        class="w-full px-4 py-3 border border-slate-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 text-slate-700 resize-none"
        formControlName="reference_document_remark"
        maxlength="500"
        autocomplete="off"
        placeholder="Enter document description (max 500 chars)"
      ></textarea>
      <div class="flex justify-end mt-1">
        <small class="text-slate-400">
          {{ kmpForm.get('reference_document_remark')?.value?.length || 0 }}/500
        </small>
      </div>
    </div>
    <div class="mb-4">
      <label class="block text-sm font-semibold text-slate-700 mb-2">Upload File</label>
      <div *ngIf="uploadedFilePath || (file?.length)" class="mb-2">
        <a [href]="uploadedFilePath" target="_blank" class="inline-flex items-center text-blue-600 hover:underline">
          <i class="pi pi-file mr-2"></i>{{ getFileName(uploadedFilePath) }}
        </a>
      </div>
      <div >
       
       
          <input
            type="file"
            [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'"
            (change)="onFileChange($event, 'file1')"
      
            required
          />
      
      </div>
    </div>
  </form>

  <footer class="flex justify-end  border-t  gap-3 bg-transparent">
    <button
      type="submit"
      class="px-6 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold shadow hover:from-blue-700 hover:to-blue-800 transition-all duration-200 flex items-center gap-2"
      *ngIf="!viewMode"
      [disabled]="kmpForm.invalid || kmpForm.pristine"
      [ngClass]="(kmpForm.invalid || kmpForm.pristine) ? 'opacity-60 cursor-not-allowed' : ''"
      (click)="onSave()"
    >
      <i class="pi pi-save"></i> Submit
    </button>
  </footer>

</p-dialog>


<p-dialog header="Delete KMP" [modal]="true" [closable]="true" [(visible)]="showDeleteDialog" [maximizable]="true"
  [style]="{ width: '30rem' }">
  <div class="delete-dialog">
    <span>Are you sure , you want to delete KMP ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()">
    </p-button>
  </div>
</p-dialog>